module.exports = __webpack_public_path__ + "assets/e13b41047e9e4b51e5253a8069741cce.svg";